module.exports = __webpack_public_path__ + "static/media/default_avatar.f3e18aca.svg";